import { Pipe, PipeTransform } from '@angular/core';
import { DocumentData } from '../../../app/modules/documents/interfaces/document-data.interface';
import { UserPermission } from '../../../app/modules/auth/enums/user-permission.enum';
import { AuthService } from '../../../app/modules/auth/services/auth.service';
import { DocumentUploaderData } from '../../../app/modules/documents/interfaces/document-uploader-data.interface';
import { OrganizationsService } from '../../../app/modules/organizations/services/organizations.service';
import { OrganizationData } from '../../../app/modules/organizations/interfaces/OrganizationData';

@Pipe({
    name: 'isDeletableDocument',
    standalone: false,
})
export class IsDeletableDocumentPipe implements PipeTransform {
    public foundedIndex: number = -1;

    constructor(private authService: AuthService, private orgSelector: OrganizationsService) {}

    transform(document: DocumentData, documentUploaders: DocumentUploaderData[] | null): boolean {
        if (!documentUploaders) {
            return false;
        }

        if (this.authService.hasAtLeastOneRole([UserPermission.DocumentsDeleteAny])) {
            return true;
        }

        if (this.authService.hasAtLeastOneRole([UserPermission.DocumentsDeleteLower])) {
            const uploaderCompanyId = this.getCompanyIdForUploader(document.uploaded_by, documentUploaders);
            // TODO idp just use async or smth here for foundedIndex
            this.orgSelector.loadedVisibleCompanies.asObservable().subscribe((val) => {
                if (val) {
                    const ids = this.orgSelector.companiesVisibleForUser.map((item: OrganizationData) => item.id);
                    this.foundedIndex = ids.indexOf(uploaderCompanyId);
                    return ids.indexOf(uploaderCompanyId) >= 0;
                } else {
                    return false;
                }
            });
        }
        if (this.foundedIndex >= 0) {
            this.foundedIndex = -1;
            return true;
        }

        if (this.authService.hasAtLeastOneRole([UserPermission.DocumentsDeleteOwned])) {
            return this.authService.jwtUser !== null && document.uploaded_by === this.authService.jwtUser.UserId;
        }

        return false;
    }

    private getCompanyIdForUploader(uploaderId: string, documentUploaders: DocumentUploaderData[]): string {
        const uploadersFiltered = documentUploaders.filter((uploaderData) => uploaderData.id === uploaderId.toString());

        // This should always contain one value only (however, return 0 otherwise)
        return uploadersFiltered.length > 0 ? uploadersFiltered[0].companyId : '';
    }
}
